import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { Link } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import { Box, CircularProgress, Typography, List, ListItem, Card, CardContent, Divider } from '@mui/material';

const PendingApprovals = () => {
  const [pendingForms, setPendingForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token');
  const { role } = jwtDecode(token);

  useEffect(() => {
    const fetchPendingForms = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/active-workflows/pending-approvals/${role}`);
        const userPendingForms = response.data.workflows;
        console.log(userPendingForms)
        setPendingForms(userPendingForms);
      } catch (error) {
        console.error('Error fetching pending forms', error);
        enqueueSnackbar('Failed to fetch pending forms', { variant: 'error' });
      } finally {
        setLoading(false);
      }
    };

    fetchPendingForms();
  }, [role]);

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Pending Approvals
      </Typography>
      {pendingForms.length > 0 ? (
        <List>
          {pendingForms.map((form) => (
            <ListItem key={form._id} sx={{ mb: 2 }}>
              <Card sx={{ width: '100%' }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    <strong>Filled By:</strong>
                  </Typography>
                  <List>
                    <ListItem>
                      <Typography variant="body1" color="textPrimary">
                        <strong>Name:</strong> {form.filledBy.name}
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1" color="textPrimary">
                        <strong>Role:</strong> {form.filledBy.role.name}
                      </Typography>
                    </ListItem>
                  </List>
                  <Divider sx={{ my: 2 }} />
                  <Link to={`${form._id}`} style={{ textDecoration: 'none' }}>
                    <Typography variant="body2" color="primary">
                      View Details
                    </Typography>
                  </Link>
                </CardContent>
              </Card>
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography>No pending approvals.</Typography>
      )}
    </Box>
  );
};

export default PendingApprovals;
